var CostCalculator = (function($) {

  // ### Selectors
  var _s = {
    container: '.chm-block-cost-calculator',
    collapsible: '.table__collapsible',
    collapsibleTrigger: '.js-collapsibleTrigger',
    collapsibleBody: '.table__collapsible-body',
    calculator: '.table__calculator',
    calculatorCell: '.table__calculator .table-cell:not(.label)',
    calculatorCHMPlus: '.table__calculator__chm-plus',
    calculatorTotal: '.table__calculator__total'
  };

  // ### Update Total
  function updateTotal() {
    let total = 0;

    $(_s.calculatorCell+'.active').each(function(i) {
      let cost = $(this).data('cost');
      total += cost;
    });

    $(_s.calculatorCHMPlus+' input[type=checkbox]:checked').each(function(i) {
      let cost = $(this).parents(_s.calculatorCHMPlus).data('cost');
      total += cost;
    });

    let start_val = parseInt($(_s.calculatorTotal).html());

    let anim = new countUp.CountUp($(_s.calculatorTotal)[0], total, {
      startVal: start_val,
      duration:0.75,
    });

    if (!anim.error) {
      anim.start();
    } else {
      console.error(anim.error);
    }

  }

  // ### Init
  var _init = function() {
    _bindEvents();
  };

  // ### Bind Events
  var _bindEvents = function() {
    $(_s.collapsibleTrigger).on('click', function() {
      $(this).parents(_s.collapsible).toggleClass('active');
      $(this).siblings(_s.collapsibleBody).slideToggle('fast');
    });

    // Calculator - choose program
    let DL_calculator_click = {}; // initialize DL object
    $(_s.calculatorCell).on('click', function() {
      if ( !$(this).hasClass('disabled') ) {
        $(this).siblings().removeClass('active');
        $(this).toggleClass('active');
  
        // if unchecked, remove CHM Plus
        if ( !$(this).hasClass('active') ) {
          $(this).parents('.table-row').find(_s.calculatorCHMPlus+' input').prop('checked', false);
        }

        const customer = $(this).parents('.table-row').data('customer');
        const program = $(this).data('program');

        // Only send DL `calculator_click` for first interaction
        if ( Object.keys(DL_calculator_click).length == 0 ) {
          dataLayer.push({
            event: 'tool_engagement',
            tool_name: 'cost_calculator',
            engagement_type: 'calculator_click',
          });
        }

        let selection;
        switch(customer) {
          case "for-myself" :
            selection = `self_${program}`;
            break;
          case "for-my-spouse" :
            selection = `spouse_${program}`;
            break;
          case "for-my-dependents" :
            selection = `dependent_${program}`;
            break;
        }

        // Only send DL `program_selection` once per row
        if ( ! DL_calculator_click[customer] ) {
          dataLayer.push({
            event: 'tool_engagement',
            tool_name: 'cost_calculator',
            engagement_type: 'program_selection',
            selection: selection
          });
        }  
        
        DL_calculator_click[customer] = program;
      }

      updateTotal();
    });

    // Calculator - add CHM Plus
    let DL_plus_toggle = {}; // initialize DL object
    $(_s.calculatorCHMPlus+' input[type=checkbox]').on('change', function() {

      const customer = $(this).parents('.table-row').data('customer');
      const program = "chm_plus";

      // Only send DL `plus_toggle` for first interaction
      if ( Object.keys(DL_plus_toggle).length == 0 ) {
        dataLayer.push({
          'tool_name': 'cost_calculator',
          'engagement_type': 'plus_toggle',
          'event': 'tool_engagement'
        });
      }

      let selection;
      switch(customer) {
        case "for-myself" :
          selection = `self_${program}`;
          break;
        case "for-my-spouse" :
          selection = `spouse_${program}`;
          break;
        case "for-my-dependents" :
          selection = `dependent_${program}`;
          break;
      }

      // Only send DL `chm_plus_selection` once per row
      if ( ! DL_plus_toggle[customer] ) {
        dataLayer.push({
          event: 'tool_engagement',
          tool_name: 'cost_calculator',
          engagement_type: 'chm_plus_selection',
          selection: selection
        });
      }  
      
      DL_plus_toggle[customer] = program;

      updateTotal();
    });
    
  };

  return {
    init: _init
  };

})(jQuery);